import {
  GET_AVAILABLE_LANGUAGES,
  SET_AVAILABLE_LANGUAGES,
  SET_SELECTED_LANGUAGE,
  TOGGLE_PREFERENCES_MODAL,
  TOGGLE_PROFILE_OPTIONS_MODAL,
} from '../action-types/app-types';
import axios from 'axios';

const ENDPOINT =
  window['runConfig'].frumBaseUrl +
  process.env.REACT_APP_ENDPOINT_FRUM_PERMISSIONS;

export const togglePreferencesModalAction = (payload = true) => ({
  type: TOGGLE_PREFERENCES_MODAL,
  payload,
});

export const toggleProfileOptionsModalAction = (payload = true) => ({
  type: TOGGLE_PROFILE_OPTIONS_MODAL,
  payload,
});

export const setAvailableLanguages = languages => ({
  type: SET_AVAILABLE_LANGUAGES,
  payload: languages,
});

export const setSelectedLanguage = language => ({
  type: SET_SELECTED_LANGUAGE,
  payload: language,
});
export const getAvailableLanguages = (nodeId, brand) => ({
  type: GET_AVAILABLE_LANGUAGES,
  payload: {
    brand: brand,
    nodeId: nodeId,
  },
});

export const getAllEntities =
  ({ brandId = 1, nodeId = 1, isCorporate = false } = {}) =>
  async dispatch => {
    const endpoint = `${ENDPOINT}/${brandId}/nodes/${nodeId}/languages`;
    return axios
      .get(endpoint, { params: { restaurantNode: false, isCorporate } })
      .then(languages => {
        dispatch(setAvailableLanguages(languages.data.payload));
      });
  };
